import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER_SECONDARY,
  GET_ALL_VENDOR_EARNINGS,
  GET_ALL_HISTORY_EARNINGS,
} from "../../types";
import { setErrors } from "../errorActions";

/*******************************************
 * @DESC GET ALL VENDOR EARNINGS ACTION
 ******************************************/
export const get_all_vendor_earnings = (token, startDate, endDate) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  try {
    const getAllVendorEarnings = await axios.get(
      `${serverApi}/vendor/earnings?status=EARNINGS&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: { Authorization: token },
      }
    );
    if (getAllVendorEarnings.status === 200) {
      dispatch({
        type: GET_ALL_VENDOR_EARNINGS,
        payload: getAllVendorEarnings.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

/*******************************************
 * @DESC GET ALL HISTORY EARNINGS ACTION
 ******************************************/
export const get_all_history_earnings =
  (token, settlementId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const getAllHistoryEarnings = await axios.get(
        `${serverApi}/vendor/earnings?status=HISTORY&settlement_id=${settlementId}`,
        {
          headers: { Authorization: token },
        }
      );
      console.log(getAllHistoryEarnings);
      if (getAllHistoryEarnings.status === 200) {
        dispatch({
          type: GET_ALL_HISTORY_EARNINGS,
          payload: getAllHistoryEarnings.data && getAllHistoryEarnings.data[0],
        });
        onSuccess(settlementId);
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
